import e from"./Pagination.vue_vue&type=script&lang.js";import{render as t}from"./Pagination.vue_vue&type=template&id=849a166c&lang.js";e.render=t,e.__file="src/components/Pagination.vue";export default e;
//# sourceMappingURL=Pagination.vue.js.map
